export const TASKS_CHANGED_EVENT = 'menu-lab:tasks-changed';

export function notifyTasksChanged(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(TASKS_CHANGED_EVENT));
}
